// extracted by mini-css-extract-plugin
module.exports = {"control":"Control_control__2GZMH","button":"Control_button__N0Tz2"};